"use client";

import { useIsMobile } from "@/hooks/use-mobile";
import { useTheme } from "next-themes";
import { useMemo } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ToastProvider = () => {
  const { resolvedTheme } = useTheme();
  const isMobile = useIsMobile();

  const toastTheme = useMemo(
    () => (resolvedTheme === "dark" ? "dark" : "light"),
    [resolvedTheme]
  );

  return (
    <>
      <ToastContainer
        position={isMobile ? "top-center" : "top-right"}
        autoClose={2000}
        hideProgressBar={isMobile}
        newestOnTop
        closeOnClick
        draggable={!isMobile}
        pauseOnHover={!isMobile}
        pauseOnFocusLoss={!isMobile}
        limit={isMobile ? 1 : 3}
        closeButton={isMobile ? false : undefined}
        theme={toastTheme}
        style={
          isMobile
            ? {
                width: "min(92vw, 420px)",
                left: "50%",
                transform: "translateX(-50%)",
                top: "max(16px, env(safe-area-inset-top))",
              }
            : undefined
        }
        toastStyle={
          isMobile
            ? {
                fontSize: "0.95rem",
                lineHeight: 1.35,
                padding: "14px 16px",
                borderRadius: 10,
              }
            : undefined
        }
      />

      <style jsx global>{`
        @supports (padding: max(0px)) {
          .Toastify__toast-container--top-center,
          .Toastify__toast-container--top-left,
          .Toastify__toast-container--top-right {
            top: max(16px, env(safe-area-inset-top));
          }
        }
      `}</style>
    </>
  );
};

export default ToastProvider;
